<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="时间选择：" class="width100">
              <el-radio-group
                v-model="userFrom.date"
                type="button"
                class="mr20"
                size="small"
                @change="selectChange(userFrom.date)"
              >
                <el-radio-button
                  v-for="(item, i) in fromList.fromTxt"
                  :key="i"
                  :label="item.val"
                >{{ item.text }}
                </el-radio-button>
              </el-radio-group>
              <el-date-picker
                v-model="timeVal"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                size="small"
                type="daterange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 250px"
                @change="onchangeTime"
              />
            </el-form-item>
            <el-form-item label="类型：" class="width100">
              <el-radio-group
                v-model="userFrom.pm"
                type="button"
                @change="getList(1)"
              >
                <el-radio-button label=" ">全部 </el-radio-button>
                <el-radio-button label="1">充值 </el-radio-button>
                <el-radio-button label="0">消费 </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="关键字："
              class="width100"
              style="display: inline-block"
            >
              <el-input
                v-model="userFrom.keywords"
                @keyup.enter.native="getList(1)"
                placeholder="请输入sku/分类名称"
                class="selWidth"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  class="el-button-solt"
                  @click="getList(1)"
                />
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <cards-data :card-lists="cardLists"/>
        <div class="mb15">
          <el-button size="mini" class="mr10" @click="openVisibleMoney"
          >充值金额</el-button
          >
        </div>
      </div>
      <el-table v-loading="listLoading" :data="tableData.data" style="width: 100%" size="small" highlight-current-row>
        <el-table-column prop="recovery_order_sett_log_id" label="ID" min-width="60"/>
        <el-table-column label="类型" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.pm == 1 ? '充值' : '消费' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="settData.cate_name" label="分类" min-width="120"/>
        <el-table-column prop="settData.sku" label="sku" min-width="120"/>
        <el-table-column prop="user.phone" label="用户手机号" min-width="120"/>
        <el-table-column prop="recovery_price" label="金额" min-width="120"/>
        <el-table-column prop="balance" label="余额" min-width="120"/>
        <el-table-column prop="create_time" label="时间" min-width="120"/>
      </el-table>
      <div class="block">
        <el-pagination :page-sizes="[20, 40, 60, 80]" :page-size="userFrom.limit" :current-page="userFrom.page"
                       layout="total, sizes, prev, pager, next, jumper" :total="tableData.total"
                       @size-change="handleSizeChange" @current-change="pageChange"/>
      </div>
    </el-card>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {
  changeNowMoneyApi,
  userBalanceCardListApi
} from '@/api/user'
import cardsData from "@/components/cards";
import {alipayBalanceCardListApi, alipayBalanceLstApi, changeAlipayBalanceApi} from "@/api/accounts";
import {fromList} from "@/libs/constants";

export default {
  name: 'AlipayBalanceList',
  components: {
    cardsData,
  },
  data() {
    return {
      moren: require("@/assets/images/f.png"),
      timeVal: [],
      fromList: fromList,
      collapse: false,
      visibleDetail: false,
      dialogVisible: false,
      maxCols: 3,
      isShowSend: true,
      visible: false,
      loading: false,
      user_type: '',
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      multipleSelection: [],
      ruleForm: [],
      ids: '',
      wechatIds: '',
      uid: '',
      labelPosition: 'right',
      userProps: {
        children: 'children',
        label: 'name',
        value: 'name'
      },
      formData: {'spread_image': ''},
      userFrom: {
        page: 1,
        limit: 20,
      },
      address: [],
      grid: {
        xl: 8,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid2: {
        xl: 18,
        lg: 16,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid3: {
        xl: 8,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      addresData: [],
      groupList: [],
      labelLists: [],
      chkName: '',
      checkedPage: [],
      allCheck: false,
      cancel_time: null,
      cardLists: [],

    }
  },
  mounted() {
    this.getList('')
  },
  methods: {
    userSearchs() {
      this.getList(1)
    },
    // 选择时间
    selectChange(tab) {
      this.userFrom.date = tab;
      this.userFrom.page = 1;
      this.timeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeTime(e) {
      this.timeVal = e;
      this.userFrom.date = e ? this.timeVal.join("-") : "";
      this.userFrom.page = 1;
      this.getList(1);
    },

    // 选择时间
    selectWarehousChange(tab) {
      this.userFrom.warehous_date = tab;
      this.userFrom.page = 1;
      this.warehousTimeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeWarehousTime(e) {
      this.warehousTimeVal = e;
      this.userFrom.warehous_date = e ? this.warehousTimeVal.join("/") : "";
      this.userFrom.page = 1;
      this.getList(1);
    },
    // 列表
    getList(num) {
      this.listLoading = true
      this.userFrom.page = num ? num : this.userFrom.page;
      this.userFrom.is_authority = 0
      alipayBalanceLstApi(this.userFrom).then(res => {
        this.tableData.data = res.data.list
        this.tableData.total = res.data.count
        this.listLoading = false
        this.getCardList()
      }).catch(res => {
        this.listLoading = false
        this.$message.error(res.message)
      })
    },
    getCardList() {
      alipayBalanceCardListApi(this.userFrom)
        .then((res) => {
          this.cardLists = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    pageChange(page) {
      this.userFrom.page = page
      this.getList('')
    },
    handleSizeChange(val) {
      this.userFrom.limit = val
      this.getList('')
    },
    openVisibleMoney(){
      this.$modalForm(changeAlipayBalanceApi()).then(() => this.getList(''))
    }
  }
}
</script>

<style lang="scss" scoped>
.check {
  color: #00a2d4;
}

.selWidth {
  // width: 100% !important;
}

.dia {
  /deep/ .el-dialog__body {
    height: 700px !important;
  }
}

.text-right {
  text-align: right;
}

.container {
  min-width: 821px;

  /deep/ .el-form-item {
    width: 100%;
  }

  /deep/ .el-form-item__content {
    width: 72%;
  }
}

.vipName {
  color: #dab176
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
  font-size: 12px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 33.33%;
}

/deep/ [type=reset],
[type=submit],
button,
html [type=button] {
  -webkit-appearance: none !important;
}
</style>
